/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageObservationOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageObservationOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        'idis/map/IdisMap',
        'app/model/LayerStore',
        'idis/control/Locator',
        'app/config',
        'idis/consts/QUERY',
        'app/map/legend/LegendPane',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase, IdisMap, LayerStore, Locator, config, QUERY, LegendPane) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageObservationOverviewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageObservationOverviewPage~SignageObservationOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // レイヤーID
            _layerId: [],

            // 緯度経度
            _latlng: null,

            // ズーム
            _zoom: null,

            _layerControl: null,

            // 値を表示する項目のリスト
            target: [
                {'item':'rainfallOrOverThirty', 'area':'rainfallOrOverThirtyArea'},
                {'item':'rainfallOrOverFifty', 'area':'rainfallOrOverFiftyArea'},
                {'item':'rainfallOrOverEighty', 'area':'rainfallOrOverEightyArea'},
                {'item':'rainfallOrOverHundredFifty', 'area':'rainfallOrOverHundredFiftyArea'},
                {'item':'rainfallOrOverTwoHundred', 'area':'rainfallOrOverTwoHundredArea'},
                {'item':'rainfallOrOverTwoHundredFifty', 'area':'rainfallOrOverTwoHundredFiftyArea'},
                {'item':'defenseWaiting', 'area':'defenseWaitingArea'},
                {'item':'floodWarning', 'area':'floodWarningArea'},
                {'item':'evacuationDecision', 'area':'evacuationDecisionArea'},
                {'item':'floodDanger', 'area':'floodDangerArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this,function(data) {
                    var item = data;
                    this._version = item.version;
                    // レイヤー
                    this._layerId = item.layerId;

                    // 緯度経度
                    if (item.latitude && item.longitude) {
                        this._latlng = [item.latitude, item.longitude];
                    } else {
                        this._latlng = [config.map.latitude, config.map.longitude];
                    }
                    // ズーム
                    if (item.zoom) {
                        this._zoom = item.zoom;
                    } else {
                        this._zoom = 9;
                    }

                    // マップを初期化
                    this.initMap();

                    // 行政界レイヤーを表示
                    this.putFirstLayer();

                    // レイヤーを表示
                    this.showLayer();

                    // 凡例を表示
                    //this.showLegend();

                }), function(error) {
                    // 処理失敗時はエラーログを出力し、エラーダイアログを表示
                    console.error(error);
                    this.chain.infoError(error);
                });

                this.setObservationOverviewInfo();
            },

            /**
             * 観測情報を設定します
             */
            setObservationOverviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 観測情報を設定
                    var observationOverview = item.items.filter(function(element) {
                        return element.municipalityCd !== null;
                    });
                    this.setObservationOverview(this, observationOverview);

                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var observationOverview = {};
                        this.setObservationOverview(this, observationOverview);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 概況情報を設定します
             */
            setObservationOverview: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item].toLocaleString() ;
                    console.log(target);
                });

                // 0箇所の場合の背景色・文字色変更
                if (item[0].rainfallOrOverThirty === 0) {
                    domClass.remove(this.rainfallOrOverThirtyArea, 'or-over-30');
                    domClass.add(this.rainfallOrOverThirtyArea, 'zero');
                } 
                if (item[0].rainfallOrOverFifty === 0) {
                    domClass.remove(this.rainfallOrOverFiftyArea, 'or-over-50');
                    domClass.add(this.rainfallOrOverFiftyArea, 'zero');
                } 
                if (item[0].rainfallOrOverEighty === 0) {
                    domClass.remove(this.rainfallOrOverEightyArea, 'or-over-80');
                    domClass.add(this.rainfallOrOverEightyArea, 'zero');
                } 
                if (item[0].rainfallOrOverHundredFifty === 0) {
                    domClass.remove(this.rainfallOrOverHundredFiftyArea, 'or-over-150');
                    domClass.add(this.rainfallOrOverHundredFiftyArea, 'zero');
                } 
                if (item[0].rainfallOrOverTwoHundred === 0) {
                    domClass.remove(this.rainfallOrOverTwoHundredArea, 'or-over-200');
                    domClass.add(this.rainfallOrOverTwoHundredArea, 'zero');
                } 
                if (item[0].rainfallOrOverTwoHundredFifty === 0) {
                    domClass.remove(this.rainfallOrOverTwoHundredFiftyArea, 'or-over-250');
                    domClass.add(this.rainfallOrOverTwoHundredFiftyArea, 'zero');
                } 
                if (item[0].defenseWaiting === 0) {
                    domClass.remove(this.defenseWaitingArea, 'defense-waiting');
                    domClass.add(this.defenseWaitingArea, 'zero');
                } 
                if (item[0].floodWarning === 0) {
                    domClass.remove(this.floodWarningArea, 'floodWarningArea');
                    domClass.add(this.floodWarningArea, 'zero');
                } 
                if (item[0].evacuationDecision === 0) {
                    domClass.remove(this.evacuationDecisionArea, 'evacuation-decision');
                    domClass.add(this.evacuationDecisionArea, 'zero');
                } 
                if (item[0].floodDanger === 0) {
                    domClass.remove(this.floodDangerArea, 'flood-danger');
                    domClass.add(this.floodDangerArea, 'zero');
                } 

                // 更新状態を設定
                this.setObservationOverviewUpdate(self, item);
            },

            /**
             * 概況情報の更新状態を設定します
             */
            setObservationOverviewUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var observationOverview = prevItem.items[0];
                if (observationOverview) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (observationOverview[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            initMap: function () {
                // マップの初期化
                this.map = new IdisMap(this.id + '-map', {
                    config: config.map,
                    keyboard: false, // コメント時に+/-が使用できないため
                    touchExtend: false, // IE対応
                    minZoom: 9,
                    maxZoom: 18,
                    drawControlTooltips: false
                }).setView(this._latlng, this._zoom);

                // mapのdestroyはremoveでDojoと互換なのでownで消せる
                this.own(this.map);

                this._layerControl = this.map.layerControl;

            },

            showLayer: function() {
                // 指定したレイヤーを表示
                var layerQuery = Locator.getLayerQuery();

                // 36 雨量観測情報(60分)(固定レイヤー)
                layerQuery[36] = layerQuery[36] || '0';
                // 38 河川水位情報(固定レイヤー)
                layerQuery[38] = layerQuery[38] || '0';
                // 39 危機管理型水位計情報(固定レイヤー)
                layerQuery[39] = layerQuery[39] || '0';

                // URLに反映
                Locator.replaceState(QUERY.LAYER_LIST, Locator.toLayerQuery(layerQuery));
            }

            //showLegend: function() {}
        });
    });
